import React, { useMemo } from 'react'
import SignIn from './sign-in'
import MainLayout from '../../../components/auth/main-layout'

const B2BSignIn = ({ tenant }) => {
  const selfRegistrationIsEnabled = useMemo(() => {
    const provider = tenant.loginProviders.find(
      (lp) => lp.providerType === 'USERNAME'
    )

    if (
      provider?.selfRegistrationDomains?.length &&
      provider?.selfRegistration
    ) {
      return true
    }

    return false
  }, [tenant])

  return (
    <MainLayout showRegistrationCta={selfRegistrationIsEnabled}>
      <SignIn />
    </MainLayout>
  )
}

export default B2BSignIn
